import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { ThemeProvider } from './state/theme';
import { UpdateToast } from './components/UpdateToast';
import './rw2-live-capture-bridge';

// P1 (founder B3): build stamp for the fresh-release proof — readable via
// console and DOM (document.documentElement.dataset.build).
document.documentElement.dataset.build = __BUILD_ID__;
console.info('[il-prof] build', __BUILD_ID__);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
      <UpdateToast />
    </ThemeProvider>
  </StrictMode>
);
